export const scrollToTop = (behavior: "auto" | "smooth") => {
    const formContainerElementArr = document.getElementsByClassName("form-body");
    const formContainer = formContainerElementArr[0];
    if (formContainer && typeof (formContainer as HTMLElement).scrollTo === "function") {
        (formContainer as HTMLElement).scrollTo({
            top: 0,
            left: 0,
            behavior
        });
    }
}

export const scrollToFormSection = (selectedNavItemId: string | undefined) => {
    if (selectedNavItemId !== undefined) {
        const formContainerElementArr = document.getElementsByClassName("form-page-section");
        if (formContainerElementArr?.length && formContainerElementArr[0]) {
            const formSectionId = selectedNavItemId.includes("link") ?
                selectedNavItemId.replace("link", "section") :
                selectedNavItemId;

            const formSectionElement = document.getElementById(formSectionId);

            if (formSectionElement) {
                formSectionElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }
}